import { isUserHasRole } from 'app/KinerjaShared/utils/profile'

import type { KinerjaProfil } from 'types/kinerja'

/**
 * Checks if the user has the Kepala SPNF Definitif role.
 * @param data - The KinerjaProfil data.
 * @returns A boolean indicating whether the user has the Kepala SPNF Definitif role.
 */
export const isUserHasKsSPNFRole = (data: KinerjaProfil) => {
  return isUserHasRole(data, 'KS_DEFINITIF_SPNF')
}

/**
 * Checks if the user has the Plt Kepala SPNF role.
 * @param data - The KinerjaProfil data.
 * @returns A boolean indicating whether the user has the Plt Kepala SPNF role.
 */
export const isUserHasKsSPNFPltRole = (data: KinerjaProfil) => {
  return isUserHasRole(data, 'KS_PLT_SPNF')
}

export const isKsSPNFDefinitifPlt = (data: KinerjaProfil) => {
  return isUserHasKsSPNFRole(data) || isUserHasKsSPNFPltRole(data)
}
